import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    beneficiariesDoneTitle: 'Completed by the beneficial owners',
    beneficiariesPendingText:
      'The beneficial owners have completed their information and we are currently reviewing it.',
    beneficiariesValidText:
      'The information regarding the beneficial owners have been validated by our team!',
    beneficiariesWaitingText:
      'Ensure that all beneficial owners of your company have completed their information. We need it to finalize the creation of your account.',
    beneficiariesWaitingTitle: 'To be completed by the beneficial owners',
    beneficiaryNextText:
      'The account owner will be notified once your application has been accepted.',

    cardTitle: 'Get updates on the mobile app',
    delay: 'This takes 48h on average',
    documentSent: 'Sent',

    primaryApplicantPendingLabel: 'Your documents are ready to be verified.',
    primaryApplicantTitle: 'Completed by you',
    primaryApplicantValidLabel: 'Your documents are verified.',
    titleUnderReview: 'You’re all set!\nWe’re reviewing your account',
    titleWaitingBeneficiaries:
      'Thanks! One last thing before reviewing your information',
  },
  fr: {
    beneficiariesDoneTitle: 'Complétés par les bénéficiaires effectifs',
    beneficiariesPendingText:
      'Les bénéficiaires effectifs ont complété leurs informations, et nous sommes en train de les étudier.',
    beneficiariesValidText:
      'Les informations des bénéficiaires effectifs ont été validées par nos équipes\u00A0!',
    beneficiariesWaitingText:
      'Pour que nous puissions finaliser la création de votre compte, assurez-vous que tous les bénéficiaires effectifs de votre entreprise ont bien rempli leurs informations.',
    beneficiariesWaitingTitle: 'À compléter par les bénéficiaires effectifs',
    beneficiaryNextText:
      'Nous notifierons le ou la propriétaire du compte lorsque votre demande sera acceptée.',

    cardTitle: 'Recevez vos notifications en temps réel sur l’application',
    delay: 'Cela prend 48 heures en moyenne',
    documentSent: 'Envoyé',

    primaryApplicantPendingLabel: 'Vos documents sont prêts à être vérifiés.',
    primaryApplicantTitle: 'Complétés par vous',
    primaryApplicantValidLabel: 'Vos documents sont validés.',
    titleUnderReview: 'C’est parti\u00A0!\nNous vérifions votre compte',
    titleWaitingBeneficiaries:
      'Merci\u00A0! Une dernière chose avant de vérifier vos informations',
  },
} as const);
